const InspectionStatus = {
    Pending: 'Pending' as 'Pending',
    Creating: 'Creating' as 'Creating',
    PreReadyToStart: 'PreReadyToStart' as 'PreReadyToStart',
    ReadyToStart: 'ReadyToStart' as 'ReadyToStart',
    InProgress: 'InProgress' as 'InProgress',
    Cancelled: 'Cancelled' as 'Cancelled',
    Error: 'Error' as 'Error',
    Finalising: 'Finalising' as 'Finalising',
    FailedPendingRecheck: 'FailedPendingRecheck' as 'FailedPendingRecheck',
    Failed: 'Failed' as 'Failed',
    Passed: 'Passed' as 'Passed',
    ATComplete: 'AT To Complete'
};

type InspectionStatusLiteral = typeof InspectionStatus;
type InspectionStatus = InspectionStatusLiteral[keyof InspectionStatusLiteral];

export { InspectionStatus }
